import React from 'react';

import { useTheme } from '@mui/material/styles';
import {
    IconButton,
    Menu,
    MenuItem,
    Tooltip
} from "@mui/material"

import imgUrl from '../../../../img/default.svg'
import MoreIcon from '../../../icons/MoreIcon';
import CalendarIcon from '../../../icons/CalendarIcon';
import TrashIcon from '../../../icons/TrashIcon';
import { AddBox, Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const CardElement = (props) => {
    const {
        item,
        t,
        handleDeleteClicked,
        handleClick,
        type,
        setVersionsDialogOpen,
        setSelectedFloorPlan,
        screenshot
    } = props;

    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState(null)
    const theme = useTheme();
    const open = Boolean(anchorEl)

    const handleMoreClick = (event) => {
        setAnchorEl(event.currentTarget); event.stopPropagation();
    }

    const handleClose = (event) => { setAnchorEl(null); event.stopPropagation() }

    return (
        <Tooltip title={item.name} placement="top">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '240px',
                    backgroundColor: theme.palette.background.secondary,
                    borderRadius: '12px',
                    padding: '8px',
                    gap: '8px',
                    cursor: 'pointer'
                }}
                onClick={(event) => { handleClick(item.id) }}
            >
                <div style={{ height: '144px', width: '100%', maxWidth: '100%', flexShrink: '0' }}>
                    <div
                        style={{
                            backgroundColor: theme.palette.background.navbarButton,
                            width: '100%',
                            height: '100%',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <img src={screenshot ? screenshot : imgUrl} style={{maxHeight: '100%', maxWidth: '100%'}} alt='project' loading='lazy' />
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', flexShrink: '1', gap: '5px', overflow: 'hidden' }}>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            color: theme.palette.text.secondary
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <CalendarIcon />
                            <div style={{fontSize: '12px'}}>
                                {new Date(item.created_at).toLocaleDateString()}
                            </div>
                        </div>
                        <div>
                            <IconButton onClick={handleMoreClick} style={{ padding: '0px' }}>
                                <MoreIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left'
                                }}
                                sx={{
                                    '& .MuiPaper-root': {
                                        backgroundColor: theme.palette.background.navbarButton
                                    }
                                }}
                            >
                                <MenuItem onClick={(event) => handleDeleteClicked(event, item.id)} style={{ gap: '10px' }}>
                                    <TrashIcon /> {t('Delete')}
                                </MenuItem>

                                {
                                    type == 'floorPlan' && (
                                        <MenuItem
                                            onClick={(event) => {
                                                event.preventDefault();
                                                event.stopPropagation();

                                                navigate('/app/easy-floor/edit/'+item.id);
                                            }}
                                            style={{ gap: '10px' }}
                                        >
                                            <Edit style={{color: "#638CA3" }} /> {t('Edit')}
                                        </MenuItem>
                                    )
                                }
                                {
                                    type == 'floorPlan' && item.multiple_versions_enabled ? (
                                        <MenuItem
                                            onClick={(event) => {
                                                event.preventDefault();
                                                event.stopPropagation();

                                                setVersionsDialogOpen(true);
                                                setSelectedFloorPlan(item);
                                                handleClose(event);
                                            }}
                                            style={{ gap: '10px' }}
                                        >
                                            <AddBox style={{color: "#638CA3" }} /> {t('Versions')}
                                        </MenuItem>
                                    ) : null
                                }
                            </Menu>
                        </div>
                    </div>
                    <div style={{ fontSize: '14px', lineHeight: '24px' }}>
                        {item.name}
                    </div>
                </div>
            </div>
        </Tooltip>
    );
}

export default CardElement;